<template>
<section class="container mt-5">
  <PagesPath
  :pathTitle="'درباره ثریا مارکت'"
        :pathTitle1="'درباره ما '"
        :pathTo1="'/about'"
      ></PagesPath>
<p class="paragragh">
  Lorem ipsum dolor, 
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.
</p>
<figure>
 <img class="w-100" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTsX0yQ4AD8GOCOn5U2LGDvoHQKNgD4iKq0QkUyHFS0_g&s" alt=""> 
</figure>
<p class="paragragh">
  Lorem ipsum dolor, 
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ducimus error numquam officia neque, similique necessitatibus inventore, nam illum consectetur nulla totam ab harum quos excepturi iste cupiditate impedit quidem nostrum.
</p>

</section>
</template>
<style scoped>
.paragragh{
  line-height: 30px;
  font-size: 18px;
  margin: 20px 0;
}
</style>

<script>
import PagesPath from "@/parts/Front/components/PagesPath";
import TrustedCustomers from "@/parts/Front/components/about-us/Trusted-customers";
import CollaborateWith from "@/parts/Front/components/about-us/Collaborate-with";
import infoDownAbout from "@/parts/Front/components/about-us/info-down-about";
export default {
  name: "AboutUs",
  components:{
    PagesPath,
    TrustedCustomers,
    CollaborateWith ,
    infoDownAbout
  },
  data() {
    return {
      options: [
        {
          'title': 'تضمین اصالت'
        },
        {
          'title': 'قیمت مناسب'
        },
        {
          'title': 'کیفیت خوب'
        }
      ]
    }
  },
  mounted() {
    // let aboutUsImg=document.querySelectorAll('.about-us-why-img')[0];
    // aboutUsImg.style.height = (aboutUsImg.offsetWidth * 1.2) + "px";
    // window.addEventListener('resize' , function() {
    //   let aboutUsImg=document.querySelectorAll('.about-us-why-img')[0];
    //   aboutUsImg.style.height = (aboutUsImg.offsetWidth * 1.2) + "px";
    // });
  }
}
</script>

<style scoped>
.line-about{
  height: 1px;
  background-color: #E7E7E7;
  flex-grow: 1;
}
.image-about{
  position: relative;
  top: -200px;
  margin: 0 auto !important;
  margin-bottom: -170px !important;
}
.content-about{
  margin-top: 230px;
}
.image-about img{
  object-fit: cover;
}
@media screen and (max-width:998px) {
  .image-about{
    position: relative;
    top: -95px;
    margin-bottom: -80px !important;
  }
  .content-about{
    margin-top: 125px;
    
  }
  
}
@media screen and (max-width:768px) {
  .image-about{
    
    padding: 0 30px !important;
    height: 210px;
    
  }
  .image-about img{
    object-fit: cover;
    height: 210px;
  }
 
  
}
</style>